import { Dispatch, SetStateAction } from "react";
import { BulkSitesChangeDetailsDTO } from "../../api-client-nswag/taxportal-client";
export interface BulkSiteGridProps {
  userEmail: string;
  setBulkSiteMainPage: Dispatch<SetStateAction<boolean>>;
}
export interface LoadExcelFileModalProps {
  setBulkSiteMainPage: Dispatch<SetStateAction<boolean>>;
}
export interface ModalBulkSiteCreationProps {
    handleClose: () => void;
    isDisplayModal: boolean;
    siteId: string | undefined;
    userEmail: string
 }
 export interface ModalBulkSiteCreationSubDetailProps {
    id: string;
    isDisplayModal: boolean;
    handleClose: () => void;
 }

 export interface changesDetailData {
    pending: boolean;
    changes: BulkSitesChangeDetailsDTO[];
 }

 export const constants = {
   ACTIVE: "ACTIVE",
   SITES_SELECTED_TITLE: "Review changes",
   DETAILS_TITLE: "Process Execution Detail",
 };
